/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import ArtistProfile from '../containers/Artists/shared/ArtistProfile';
import HomeFooter from '../containers/Home/HomeFooter';
import { artistsData } from '../containers/Artists/shared/artistsData';

const Swat = () => (
  <div>
    <ArtistProfile artist={artistsData.swat} />
    <HomeFooter />
  </div>
);

export default Swat;
